import {
    SEARCH_CITY,
    SEARCH_COUNTY,
    SEARCH_CITY_SUCCEEDED,
    SEARCH_COUNTY_SUCCEEDED
} from './types';

export const searchCityByTerm = (payload) => ({
    type: SEARCH_CITY,
    payload,
});

export const searchCountyByTerm = (payload) => ({
    type: SEARCH_COUNTY,
    payload,
});

export const citySucceeded = (payload) => ({
    type: SEARCH_CITY_SUCCEEDED,
    payload,
});

export const countySucceeded = (payload) => ({
    type: SEARCH_COUNTY_SUCCEEDED,
    payload,
});



// WEBPACK FOOTER //
// ./src/SHARED/actions/geolocation.actions.js